// Pages/NotFound.js
import React from "react";

export default function Test() {
  return (
    <main>
      {/* <div style={{ textAlign: "center", padding: "2rem" }}>
        <h1>Test d’affichage d’image</h1>
        <img
          src="https://media.cdnws.com/_i/139692/8846/450/49/579-4.png"
          alt="Image de test"
          style={{ maxWidth: "100%", height: "auto" }}
        />
      </div> */}
    </main>
  );
}
